import React from 'react';

const BtnCancel = (props) => {
  const { handleCancelEdit } = props
  return (
    <button 
      className={`main-button thi`} 
      onClick={() => handleCancelEdit()}>
      CANCELAR
    </button>
  )
}
const BtnSaveNew = (props) => {
  const { handleSelectItem } = props
  return (
    <button 
      className={`main-button thi`} 
      onClick={() => handleSelectItem()}>
      SALVAR
    </button>
  )
}
const BtnAddNew = (props) => {
  const { handleNewItem } = props
  return (
    <button 
      className={`main-button thi`} 
      onClick={() => handleNewItem()}>
      NOVO
    </button>
  )
}
const BtnRemove = (props) => {
  const { handleDeleteItem } = props
  return (
    <button 
      className={`main-button thi`} 
      onClick={() => handleDeleteItem()}>
      EXCLUIR
    </button>
  )
}
const BtnEdit = (props) => {
  const { handleEditItem } = props
  return (
    <button 
      className={`main-button thi`} 
      onClick={() => handleEditItem()}>
      EDITAR
    </button>
  )
}

const LoginButton = (props) => {
  const { functions } = props
  return (
    <button 
      className={`main-button thi`} 
      onClick={() => functions.handleLogn()}>
      { `LOGIN`}
    </button>
  )
}
const LoggedButtons = (props) => {
  const { 
    st_addit, 
    st_eddit,
    bttn_sv, 
    logged,
    functions
  } = props
  return (
    <React.Fragment>
      { st_eddit && (
        <div className="parent-body-wrap">
          <BtnCancel {...props} />
          <BtnSaveNew {...props} />
        </div>
      )}
      { st_addit && (
        <div className="parent-body-wrap">
          <BtnCancel {...props} />
          <BtnSaveNew {...props} />
        </div>
      )}
      { !st_addit && !st_eddit && (
        <div className="parent-body-wrap three">
          <BtnAddNew {...props} />
          <BtnRemove {...props} />
          <BtnEdit {...props} />
        </div>
      )}
      <button 
        className={`main-button thi`} 
        onClick={() => functions.handleLgot()}>
        { `LOGOUT`}
      </button>
    </React.Fragment>
  )
}

const MenuBottom = (props) => {
  const { logged } = props
  return (
    <div className="parent-body-bottom">
      { logged && <LoggedButtons {...props} /> }
      { !logged && <LoginButton {...props} /> }
    </div>
  )
}

export default MenuBottom;